import { Tabs } from '@mantine/core';
import IncomingWebhooks from '@/pages/Integrations/components/IncomingWebhooks';
import Webhooks from '@/pages/Integrations/components/Webhooks';

interface WebhooksModalContentProps {
    connectorIdn: string;
}

const WebhooksModalContent = ({ connectorIdn }: WebhooksModalContentProps) => {
    return (
        <Tabs defaultValue="outgoing">
            <Tabs.List>
                <Tabs.Tab value="outgoing">Outgoing</Tabs.Tab>
                <Tabs.Tab value="incoming">Incoming</Tabs.Tab>
            </Tabs.List>

            <Tabs.Panel className="pt-4" value="outgoing">
                <Webhooks connectorIdn={connectorIdn} />
            </Tabs.Panel>
            <Tabs.Panel className="pt-4" value="incoming">
                <IncomingWebhooks connectorIdn={connectorIdn} />
            </Tabs.Panel>
        </Tabs>
    );
};

export default WebhooksModalContent;
